<div class="driver-modal">
  <div class="sec_head pad_btm">
    <h2>{{ 'ProvideReason' | translate }}</h2>
  </div>

  <div class="modal-body">
    <form class="attribute-modal">
      <div class="form_group">
        <mat-form-field appearance="fill">
          <input
            matInput
            class="form_grup txt-area"
            [(ngModel)]="rejectionReason"
            [ngModelOptions]="{ standalone: true }"
            class="form_control" />
        </mat-form-field>
      </div>
      <div class="error-box">
        <mat-error *ngIf="submitted && showError">{{
          'ProvideReason' | translate
        }}</mat-error>
      </div>
    </form>
  </div>
  <div class="submit_btn flex_btn">
    <button class="btnn btn_primary" type="submit" (click)="submit()">
      {{ 'Save' | translate }}
    </button>
  </div>
</div>
